import { LogOutIcon } from "lucide-react";
import { useAuth } from "../../lib/authContext";

export const LogoutButton = ({ size }: { size: number }) => {
  const { signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error logging out:", (error as Error).message);
    }
  };
  return (
    <LogOutIcon onClick={handleLogout} size={size} className="cursor-pointer" />
  );
};
